module.exports = "/images/Run Better Loyalty and Vip Programs.svg?f5a9ff8d41ec13024bccce687dad4b09";